import axios from '../../axios-orders'

import * as actionTypes from "./actionTypes";
export const addIngredient = (name) => {
  return {
    type: actionTypes.ADD_INGREDIENT,
    ingredientName: name,
  };
};

export const removeIngredient = (name) => {
  return {
    type: actionTypes.REMOVE_INGREDIENT,
    ingredientName: name,
  };
};

export const setIngredients = (ingredients) => {
  console.log("Inside setIngredients...")
  console.log(ingredients);

  return {
    type: actionTypes.SET_INGREDIENTS,
    ingredients: ingredients,
  };
};
export const fetchIngredientsFailed=()=>{
    return {
        type:actionTypes.FETCH_INGREDIENTS_FAILED

    }
}

export const initIngredients = () => {
  console.log("hello");
  return (dispatch) => {
    axios
    .get("ingredients.json")
    .then((resp) => {
      console.log(resp);
      dispatch(setIngredients(resp.data));
    })
    .catch((err) => {
      dispatch(fetchIngredientsFailed())
    });
  };
};
